import { Component, OnInit } from '@angular/core';
import { CasesAdminService, listAllCaseAdministrativeOutput } from '../../services/cases-admin.service';
import { Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-cases-admin',
  templateUrl: './cases-admin.component.html',
  styleUrls: ['./cases-admin.component.scss']
})
export class CasesAdminComponent implements OnInit {
  loading: boolean = true;
  casesDisponiveis: listAllCaseAdministrativeOutput[] = [];

  total: number = 0;
  pageLength: number = 10;
  page: number = 1;

  constructor(
    private readonly service: CasesAdminService,
    private readonly router: Router,
    private readonly snack: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.findCases('AVAILABLE');
  }

  createCase(): void {
    this.router.navigate(['/cases-admin/novo-caso']);
  }

  editCase(leadId: number): void {
    this.router.navigate([`/cases-admin/${leadId}`]);
  }

  inactiveCaseEvent(event: number ){
    this.inactivateCase(event);
  }

  pageChange(event?: PageEvent){
    this.page = event.pageIndex + 1;
    this.findCases('AVAILABLE');
  }

  selectedTab(event: MatTabChangeEvent){
    const currentTab = event.tab.textLabel;
    switch(currentTab){
      case 'Disponíveis':
        //if(this.casesDisponiveis.length > 0) return;
        this.findCases('AVAILABLE');
        break;
    }
  }

  private findCases(filter: string): void {
    this.loading = true;

    const pagination = {
      page: this.page,
      perPage: this.pageLength
    };

    this.service.findAllCases(filter, pagination).subscribe({
      next: ({data, total}) => {
        switch(filter){
          case 'AVAILABLE':
            this.casesDisponiveis = data;
            this.total = total;
            this.loading = false;
            break;
        }
      }
    });
  }

  private inactivateCase(caseId: number): void {
    this.service.updateCaseActiveStatus(caseId).subscribe({
      next: response => {
        if(response.status === 200){
          this.findCases('AVAILABLE');
          this.snack.open(response.message, 'OK', { duration: 3000 });
        };
      }
    });
  }
}
